<template>
  <div
    style="justify-content: center"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <div>
      <el-row :gutter="0">
        <el-col :span="24">
          <el-row
            :gutter="0"
            class="eltable row"
            style="display:flex;flex-wrap: wrap;margin-top:0px;"
          >
            <el-col :span="24">
              <div class="gridContent bggray2 fb tc">门禁授权申请详情</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc" style="height:30px">申请原因</div>
            </el-col>
            <el-col :span="20">
              <div class="gridContent" style="height:30px">{{ applyAuthorization.applycause }}</div>
            </el-col>

            <el-col :span="4">
              <div class="gridContent bggray2 tc">申请人</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ applyAuthorization.amusername }}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">申请日期</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ dateFormat(applyAuthorization.applicationtime) }}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">联系方式</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ applyAuthorization.applyusertel }}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">车牌号码</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ applyAuthorization.applyplatenumber}}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">所属门禁</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ applyAuthorization.enterschoolgate }}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">身份证号</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ applyAuthorization.idcode }}</div>
            </el-col>
            <el-col :span="4">
              <div
                class="gridContent bggray2"
                style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 119px;
              "
              >备注说明</div>
            </el-col>
            <el-col :span="20">
              <div class="gridContent" style="height: 119px">{{ applyAuthorization.memo }}</div>
            </el-col>
            <el-col :span="4">
              <div
                class="gridContent bggray2 tc"
                style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 200px;
              "
              >车辆头部照片</div>
            </el-col>
            <el-col :span="20">
              <div class="gridContent" style="height: 200px">
                <el-image
                  v-for="item,index in applyAuthorization.pics"
                  :key="index"
                  :preview-src-list="[item.url]"
                  :src="item.url"
                  style="position: relative; margin-left: 1px; object-fit: fill"
                  :disabled="true"
                  height="88px"
                  width="88px"
                />

                <!-- <div
                v-for="item in applyAuthorization.pics"
                :key="item.name"
                class="avatar"
                style="position: relative; margin-left: 1px; object-fit: fill"
              >
                <el-image 
                  v-if="
                  item.type == 'jpg' ||
                  item.type == 'png' ||
                  item.type == 'gif' ||
                  item.type == 'bmp' ||
                  item.type == 'jpeg'
                "
                :preview-src-list="applyAuthorization.pics"
                  :key="item.name"
                  height="88px"
                  :src="item.url"
                  width="88px"
                />
                </div>-->
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
  
<script>
import "@/static/css/my.css";
import { uploadPath, fileAcquisition } from "@/config/net.config.js";
import moment from "moment";
import { findApplyAuthorization } from "@/api/accessAuthorization";

export default {
  name: "accessAuthorizationDetailIframe",
  data() {
    return {
      user: {},
      applyAuthorization: {},
      //id: "e015456ccbeb4248a5c8873e566f4b44", //a473f45f069d4b34bebf4f9c07d7d3c8,e015456ccbeb4248a5c8873e566f4b44
      id: "",
      url: "",
      xzztcToken: "",
      uploadPath: uploadPath,
      fileAcquisition: fileAcquisition,
      playStatus: "",
      muteStatus: "",
      isMute: true,
      isPlay: false,
      width: "88", // 设置视频播放器的显示宽度（以像素为单位）
      height: "88", // 设置视频播放器的显示高度（以像素为单位）
      preload: "auto", //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      controls: true, // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      autoplay: "",
      srcList: [],
      contentHeight: 0,
      heightDiv: 0,
      loading: true
    };
  },
  computed: {},
  mounted() {
    this.user = JSON.parse(sessionStorage.getItem("userInfo"));
    console.log(this.user.userid);
    this.id = this.$route.query.id;
    this.findApplyAuthorization();
    this.getHeight();
  },
  methods: {
    async findApplyAuthorization() {
      let data = await findApplyAuthorization(this.id);
      this.applyAuthorization = data.data;
      this.loading = false;
      this.applyAuthorization.pics = JSON.parse(data.data.pics);
      console.log("pics==", this.applyAuthorization.pics);
      console.log("applyAuthorization===", this.applyAuthorization);
    },

    getHeight() {
      this.$nextTick(function() {
        this.contentHeight = document.getElementsByClassName(
          "row"
        )[0].clientHeight;
        this.heightDiv = this.contentHeight - 60 + "px";
        this.contentHeight = this.contentHeight + "px";
        console.log(this.contentHeight, this.heightDiv); //元素高度
      });
    },
    dateFormat(date) {
      if (date != null && date != "") {
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    goBack() {
      this.$router.push("/userCenter");
    }
  }
};
</script>
<style scoped>
.el-tabs__item.is-active {
  color: #2c3e50 !important;
  font-weight: bold;
}

.eltable {
  border-left: 1px solid #ddd;
  margin-top: 20px;
  border-top: 1px solid #ddd;
}

.eltable .gridContent {
  padding: 10px 8px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 19px;
}

.rightTable {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.rightDiv {
  padding-top: 10px;
  margin-left: 10%;
  padding-left: 5px;
  overflow-y: scroll;
}

.el-rate__icon {
  font-size: 28px;
}

.bggray2 {
  background-color: #e2f3cf;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  margin-right: 10px;
}

.avatar {
  width: 160px;
  height: 160px;
  float: left;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 10px;
  line-height: 88px;
  text-align: center;
  /* display: block;  */
}

>>> .el-image__error,
>>> .el-image__inner,
>>> .el-image__placeholder {
  width: 160px;
  height: 160px;
}

>>> .el-step__title.is-finish {
  color: rgb(17, 1, 69);
  font-size: 14px;
  /* text-align: center; */
}

>>> .el-step__head.is-finish {
  color: #008a2c;
  border-color: #008a2c;
  font-size: 14px;
  text-align: center;
  /* justify-content: center; */
}

>>> .el-step__description.is-finish {
  color: rgb(17, 1, 69);
  font-size: 14px;
  /* text-align: center; */
}

::-webkit-scrollbar {
  width: 5px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

.btn1.el-button {
  background-color: #008a2c;
  color: white;
}

.btn1.el-button:hover {
  color: white;
  border-color: #e0fae8;
  background-color: #008a2cc9;
}
</style>